export default "__VITE_ASSET__2c3ce430__"